import type { QueryClient } from '@tanstack/react-query';

import { API_SYNC_DELAY_MS } from '@/config/constants';
import { http } from '@/services/http';

import { savedFiltersOptions } from '../savedFilters.options';
import { getSavedFiltersApiUrl } from '../savedFiltersUrl';
import { broadcastSavedFiltersMutation } from '../useSavedFiltersSync';

import type { SavedFilterResponse } from '../savedFilters.types';

export const waitForApiSync = (): Promise<void> =>
  new Promise<void>(resolve => {
    setTimeout(resolve, API_SYNC_DELAY_MS);
  });

export const saveSavedFilterToApi = async (
  id: string,
  payload: SavedFilterResponse
): Promise<void> => {
  await http.internal.post(getSavedFiltersApiUrl(id), payload);
  await waitForApiSync();
};

export const deleteSavedFilterFromApi = async (id: string): Promise<void> => {
  await http.internal.delete(getSavedFiltersApiUrl(id));
  await waitForApiSync();
};

export const invalidateAndBroadcast = async (queryClient: QueryClient): Promise<void> => {
  try {
    await queryClient.invalidateQueries(
      { queryKey: savedFiltersOptions.all(), refetchType: 'active' },
      { throwOnError: true }
    );
  } finally {
    broadcastSavedFiltersMutation();
  }
};
